import '../styles/quotes.modules.css';

function Quotes({ text, person, desc}) {
    return (
        <div className="quote" style={({display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", gap: "15px", border: "7px solid #d0142d"})}>
          <div style={({display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px", width: "90%", marginTop: "20px"})}>
            <img src="quota.png" alt="Ikona" style={({width: "35px", height: "35px"})}/>
            <p className="quote_text" style={({fontWeight: "bold", color: "rgb(30,30,30)", textAlign: "center"})}>{text}</p>
          </div>
          <div style={({display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px", width: "90%"})}>
            <p className="quote_name" style={({fontWeight: "bold", color: "rgb(30,30,30)", textAlign: "center"})}>{desc}</p>
          </div>
        </div>
    );
  }
  
  export default Quotes;